import { gql } from '@apollo/client';

export const SaveUserConsent = gql`
  mutation SaveUserConsent($input: UserConsentInputType!) {
    saveUserConsent(input: $input) {
      ok
      error
    }
  }
`;
